<template>
<div id="MemberManage">


  <div
    v-if="MemberManageShow"

    class="well"
    style="padding: 0 1em"
  >
    <div style="text-align: left; padding: 0.5rem 2rem">
      <button
        href="#"
        @click="BatchAddMember()"
        class="btn btn-outline-success"
        type="button"
        style="font-size: 14px; text-align: right"
      >
        批次新增會員
      </button>
       目前學員共 {{total}}筆
    </div>

    <b-tabs content-class="mt-3" justified>
      <div
        class="dataTables_scrollBody"
        style="
          font-size: 14px;
          position: relative;
          overflow: auto;
          max-height: 100%;

          border-bottom: 1px solid #111;
          border-top: 1px solid #111;
        "
      >
        <b-table-simple
          class="ncut-table-menu-striped ncut-table-menu"
           fixed
          responsive
          bgcolor="#FFFFFF"
        >
          <b-thead class="ncut-thead-menu">
            <b-tr>
              <b-th style="min-width: 2em">會員編號</b-th>
              <b-th style="min-width: 26em">註冊日期</b-th>
              <b-th style="min-width: 5em">Email</b-th>
              <b-th style="min-width: 2em">會員帳號</b-th>
              <b-th style="min-width: 2em">姓名</b-th>
              <!-- <b-th style="min-width: 2em">已報名課程</b-th> -->
              <b-th style="min-width: 5em">優惠條件</b-th>
              <b-th style="min-width: 20em">管理</b-th>
            </b-tr>
          </b-thead>
          <b-tbody class="ncut-tbody-menu">
            <b-tr
              v-for="(item, index) in filteredDocs"
              :key="item.stdID"
              :index="item.stdID"
              :name="item.stdID"
              v-bind:style="{
                background: selectedRowIndex == index ? headerColor : '',
              }"
              @click="selectedRowIndex = index"
            >
              <b-td style="text-align: right">
                {{ item.stdID}}
              </b-td>
              <b-td style="text-align: left">
                {{ item.updateTimeString }}
              </b-td>
              <b-td style="text-align: left">{{ item.eMail }}</b-td>
              <b-td style="text-align: left">{{ item.idNo }}</b-td>
              <b-td style="text-align: left">
                {{ item.name}}
              </b-td>
               <!-- <b-td style="text-align: left">
                {{ item.c1}}
              </b-td> -->
              <b-td  style="text-align: left">
                {{discountArray[item.offer]}}
              </b-td>

              <b-td>
                <button
                  href="#"
                  @click="signUpManage(item.stdID)"
                  class="btn btn-outline-dark"
                  type="button"
                  style="font-size: 14px"
                >
                  已報名課程
                </button>
<br>

                   <button
                  href="#"
                  @click="ListDetailMemberData(item.stdID,item.memberClass)"
                  class="btn btn-outline-success"
                  type="button"
                  style="font-size: 14px"
                >
                  修改資料
                </button><br>

                <button
                  href="#"
                  @click.prevent="remove(item.stdID)"
                  class="btn btn-outline-danger btn-sm"
                  type="button"
                  style="font-size: 14px"
                >
                  刪除
                </button><br>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-pagination
          v-model="currentPage"
          :total-rows="total"
          :per-page="pageSize"
          v-if="total > pageSize"
        />
      </div>
    </b-tabs>




    <b-modal ref="q-modal" hide-footer title="請注意">
      <div class="d-block text-center">
        <h3>是否確認刪除此筆資料?</h3>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="cancalRM"
        >取消刪除</b-button
      >
      <b-button class="mt-2" variant="outline-info" block @click="confirmRM"
        >刪除確認</b-button
      >
    </b-modal>
      <b-modal size="xl"  ref="BatchAddMember" hide-footer>
      <template #modal-title> 批次新增會員 </template>
      <BatchAddMember

        @hideModal="hideModal('BatchAddMember')"
      ></BatchAddMember>
    </b-modal>



  </div>

  <div v-else  class="well" style="padding: 0 1em">
    <div style="text-align: left; padding: 0.5rem 2rem">
      <button
        href="#"
        @click.prevent="backCourseList()"
        class="btn btn-outline-secondary"
        type="button"
        style="font-size: 14px"
      >
        回會員列表
      </button>
    </div>
    <br />
    <div style="font-size: 20px; text-align: left; padding: 0.5rem 2rem">
      {{ Name }}報名清單共{{total}}筆
    </div>

    <b-tabs content-class="mt-3" justified>
      <div
        class="dataTables_scrollBody"
        style="
          font-size: 14px;
          position: relative;
          overflow: auto;
          max-height: 100%;

          border-bottom: 1px solid #111;
          border-top: 1px solid #111;
        "
      >
          <b-table-simple
          class="ncut-table-menu-striped ncut-table-menu"
          fixed
          responsive
          bgcolor="#FFFFFF"
        >
          <b-thead class="ncut-thead-menu">
            <b-tr>
              <b-th style="min-width: 1em">報名序號</b-th>
              <b-th style="min-width: 5em">課程代碼</b-th>
              <b-th style="min-width: 5em">課程名稱</b-th>
              <b-th style="min-width: 2em">學費(原價)</b-th>
              <b-th style="min-width: 2em">學費(優惠價)</b-th>
              <b-th style="min-width: 2em">審核狀態</b-th>
              <b-th style="min-width: 2em">入帳狀態</b-th>
              <b-th style="min-width: 2em">優惠方式</b-th>

            </b-tr>
          </b-thead>
          <b-tbody class="ncut-tbody-menu">
            <b-tr
              v-for="(item, index) in filteredDocs2"
              :key="item.signUpID"
              :index="item.signUpID"
              :name="item.signUpID"
              v-bind:style="{
                background: selectedRowIndex == index ? headerColor : '',
              }"
              @click="selectedRowIndex = index"
            >
              <b-td style="text-align: right">
                {{ item.signUpID }}
              </b-td>
              <b-td style="text-align: left">
                {{ item.cid }}
              </b-td>
       <b-td style="text-align: left">
                {{ item.courseName }}
              </b-td>

              <b-td style="text-align: left">{{ item.courseCost }}</b-td>
              <b-td style="text-align: left">{{ item.specialPrice }}</b-td>
              <b-td v-if="item.isComplete == 0" style="text-align: left">
                尚未審核
              </b-td>
              <b-td v-else style="text-align: left">
                {{ item.isComplete == 1 ? "報名通過" : "報名不通過" }}
              </b-td>
              <b-td v-if="item.isPayment == 0" style="text-align: left">
                尚未繳費
              </b-td>
              <b-td v-else style="text-align: left">
                {{ item.isPayment == 1 ? "銀行轉帳繳款" : "現場繳費" }}
              </b-td>

              <b-td style="text-align: left">{{ item.specialPriceClassText }}</b-td>

            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-pagination
          v-model="currentPage2"
          :total-rows="total"
          :per-page="pageSize"
          v-if="total > pageSize"
        />
      </div>
    </b-tabs>

  </div>

  <b-modal size="xl"  ref="EditEnterpriseMember2" hide-footer>
      <template #modal-title> 企業會員報名者資料檢視 </template>
      <EditEnterpriseMember2
        :StdID="editId"
        @hideModal="hideModal('EditEnterpriseMember2')"
      ></EditEnterpriseMember2>
    </b-modal>
     <b-modal size="xl"  ref="EditGeneralMember2" hide-footer>
      <template #modal-title> 會員報名者資料檢視 </template>
      <EditGeneralMember2
        :StdID="editId"
        @hideModal="hideModal('EditGeneralMember2')"
      ></EditGeneralMember2>
    </b-modal>

  </div>
</template>


<script>
import EditEnterpriseMember2 from "@/components/EditEnterpriseMemberView2.vue";
import EditGeneralMember2 from "@/components/EditGeneralMemberView2.vue";
import BatchAddMember from "@/components/BatchAddMemberView.vue";
import * as tools from "../tool";
export default {
  name: "MemberManage",
  data() {
    return {
      Name: null,
      MemberManageShow: false,
      cid: null,
      StdID: null,
      signUpID:null,
      today: null,
      signUpStatus: null,
      selected: null,
      discountArray: ["正常價", "早鳥0.9折", "本校教職員工及親友（含退休）0.9折", "二人以上同行0.9折"],
      attributesClassID: 0,
      editId: 0,
      over: 0,
      total: 0,
      isIE: false,
      inputData: null,
      inputData2: null,
      selectedRowIndex: 0,
      currentPage: 1,
      currentPage2: 1,
      pageSize: 10,
      queryInfo: {
        sysId: 0,
      },
    };
  },
  components: {
   EditEnterpriseMember2,
    EditGeneralMember2,
    BatchAddMember,
  },
  methods: {
       BatchAddMember() {
      var vm = this;
      vm.$refs["BatchAddMember"].show();
    },
    backCourseList() {
      this.MemberManageShow = true;
      this.getAllStudent();
    },
    getSignUpList2(StdID) {
      let vm = this;

      this.$http
        .get("./WebApi/ociaRep/GetociaSignUpList2/".concat(StdID))
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData2 = response.data;
            //vm.Name=vm.inputData2[0].name;
            if(vm.inputData2.length != null )
             vm.total = vm.inputData2.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },
    signUpManage(stdID) {

        this.StdID=stdID;
      this.getSignUpList2(stdID);
      this.MemberManageShow = false;
    },



    getAllStudent() {

      let vm = this;

      this.$http
        .get("./WebApi/ociaRep/GetociaStudent/")
        .then((response) => {
          if (!tools.isNull(response)) {
            vm.inputData = response.data;
            vm.total = vm.inputData.length;
          }
        })
        .catch(function (error) {
          alert("網路連線失敗" + error);
          // tools.showAlert(vm.inputData, "danger", "網路連線失敗" + error);
        });
    },

    ListDetailMemberData(id,MemberClass) {
      var vm = this;
      vm.editId = id;
      if (MemberClass == 0)
      vm.$refs["EditGeneralMember2"].show(); //普通會員
      else
      vm.$refs["EditEnterpriseMember2"].show(); //企業會員

    },
remove(StdID) {
      this.StdID = StdID;
      this.$refs["q-modal"].show();
    },
    cancalRM() {
      this.$refs["q-modal"].hide();
    },
hideModal(name){
 this.$refs[name].hide();

},
    confirmRM() { //刪除學員資料和報名資料和附件
      this.$refs["q-modal"].hide();
      var vm = this;
      this.$http
        .get("./WebApi/ociaRep/RemoveStudent/".concat(this.StdID))
        .then((response) => {
          if (response.data) {
            tools.showAlert(vm, "success", "恭喜您,刪除成功");
              vm.getAllStudent();
          } else {
            tools.showAlert(vm, "danger", "對不起,刪除失敗");
          }
        })
        .catch(function (error) {
          tools.showAlert(vm, "danger", "網路連線失敗" + error);
        });
        },

  },
  computed: {
    filteredDocs: function () {
      let data = [];
      if (this.inputData != null) {
        data = this.inputData.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
        filteredDocs2: function () {
      let data = [];
      if (this.inputData2 != null) {
        data = this.inputData2.slice(
          (this.currentPage2 - 1) * this.pageSize,
          this.currentPage2 * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },

  },
  created() {
    console.log("======created CourseManageView =====");
    this.isIE =
      navigator.userAgent.indexOf("MSIE ") > -1 ||
      navigator.userAgent.indexOf("Trident/") > -1 ||
      navigator.userAgent.indexOf("Edge") > -1;
    let vm = this;

    vm.MemberManageShow = true;
    vm.getAllStudent();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
